require('./ledgerList.scss');
const controller = require('./ledgerListCtrl').default;
const template = require('./ledgerList.html');

const deps = [
  require('data/date').name,
  require('ui/bk/angularMaterial').name,
  require('ui/bk/dndLists').name,
  require('data/model/ledger').name,
];

module.exports = angular.module('bench.ui.ledgerList', deps).component('blLedgerList', {
  bindings: {
    category: '<',
    categoryOrder: '<',
    ledgerList: '<',
    subHead: '<',
    onEdit: '<',
    onDelete: '<',
    onReorder: '<',
    onSortLedgerCategory: '<',
    showActiveLedgers: '<',
    showAccountLedgers: '<',
  },
  template,
  controller,
  controllerAs: 'vm',
});
